// This function is used as a dummy redirect when the OAUTH 2.0 redirects back to home domain.
// Authorization code is extracted from the URL on redirection.
export default function ShowCode(){
    return (null);
}
